import React from 'react';
import { WorkspacePanelButton } from '../panels/workspace-panel-button';

export const ContactListButton = function ContactListButton(): React.ReactElement {
    return (
        <WorkspacePanelButton
            tooltipText="Contact List"
            workspacePanelType="CONTACT_LIST"
            aria-label="open contact list"
            icon="ContactList"
        />
    );
};
